import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "amount-info"
};
var _hoisted_2 = {
  class: "cell"
};
var _hoisted_3 = {
  class: "left"
};
var _hoisted_4 = {
  class: "right"
};
var _hoisted_5 = {
  key: 0,
  class: "ticket-cell cell"
};
var _hoisted_6 = {
  class: "left"
};
var _hoisted_7 = {
  class: "left-item"
};
var _hoisted_8 = {
  class: "right"
};
var _hoisted_9 = {
  key: 1,
  class: "ticket-cell cell"
};
var _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left-item"
}, /*#__PURE__*/_toDisplayString('Promotion saved'))], -1);
var _hoisted_11 = {
  class: "right"
};
var _hoisted_12 = {
  class: "price red-price"
};
var _hoisted_13 = {
  class: "cell"
};
var _hoisted_14 = {
  class: "left"
};
var _hoisted_15 = {
  class: "right"
};
var _hoisted_16 = {
  class: "cell"
};
var _hoisted_17 = {
  class: "left"
};
var _hoisted_18 = {
  class: "right"
};
var _hoisted_19 = {
  class: "reason"
};
var _hoisted_20 = {
  class: "unline"
};
var _hoisted_21 = {
  key: 1,
  class: "no-address"
};
var _hoisted_22 = {
  class: "cell-right"
};
import { ref, reactive, watch, computed, onMounted } from 'vue';
import { isLoginAuthenticated, getAppConfig } from '@/utils/common';
import PopUp from '@/components/popup/PopUp.vue';
import constants, { encryptedMarketplaceId } from '@/constants';
import { getNewCustomerPromotions } from '@/models/api/promotionApi';
import { getCustomerActualPurchase } from '@/models/api/orderConfirmApi';
import { getPromotionInfosByPromotionIds, redeemPromotionForCurrentCustomer } from '@/models/api/promotionApi.js';
import { findOptimalPromotion, popUpType } from './SPCAccountingBox';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { useLess } from '@/models/hooks';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'SPCAccountingBox',
  props: {
    price: {
      type: Object,
      default: () => {
        return {
          originalShippingFee: 0,
          shippingFee: 0,
          importFee: 0,
          total: 0,
          discount: 0,
          promotionList: []
        };
      }
    },
    promotions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    addressInfo: {
      type: Object,
      default: () => null
    },
    isNewCustomer: {
      type: Boolean,
      default: () => false
    }
  },
  emits: ['updatePurchase', 'update:promotions', 'update:isNewCustomer'],
  setup(__props, {
    emit
  }) {
    var props = __props;
    var COUPON_SERVICE_PROMOTION_STATUS = constants.COUPON_SERVICE_PROMOTION_STATUS,
      ENCRYPTED_MARKETPLACE_ID = constants.ENCRYPTED_MARKETPLACE_ID;
    useLess('views/spc/orderConfirm/components/SPCAccountingBox.less');
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var GREY_TIP = `${constants.IMAGE_URL}assets/svg/greyTip.svg`;
    var promotions = ref(null);
    var promotionIds = ref([]);
    var show = ref(false);
    var popText = reactive({});
    var cptIsNewCustomer = computed({
      get: () => props.isNewCustomer,
      set: val => {
        emit('update:isNewCustomer', val);
      }
    });
    var clickHandle = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(type) {
        var configData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (type === popUpType.CSF_DESC) {
                awsRumHandler.recordClickEvent(clickEvents.checkoutPage.showImportFeeButton);
              } else {
                awsRumHandler.recordClickEvent(clickEvents.checkoutPage.showShippingFeeButton);
              }
              _context.next = 3;
              return getAppConfig(constants.ENUM_APP_CONFIG_TYPE.CHECKOUT_PAGE);
            case 3:
              configData = _context.sent;
              popText.title = configData[type].title;
              popText.content = configData[type].content;
              show.value = true;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function clickHandle(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var showCoupon = ref(false);
    var getPromotionInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(promotionId) {
        var _props$price, _yield$getPromotionIn, data, promotionList;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return getPromotionInfosByPromotionIds(promotionId);
            case 3:
              _yield$getPromotionIn = _context2.sent;
              data = _yield$getPromotionIn.data;
              promotionList = data === null || data === void 0 ? void 0 : data.miniAppPromotionList.map(item => {
                var _item$thresholds$, _item$thresholds$$cur, _item$benefits$, _item$benefits$$fixed;
                return {
                  id: item.encryptedPromotionId,
                  text: item.optimizedShortMerchandisingMessage,
                  threshold: (_item$thresholds$ = item.thresholds[0]) === null || _item$thresholds$ === void 0 ? void 0 : (_item$thresholds$$cur = _item$thresholds$.currencyAmount) === null || _item$thresholds$$cur === void 0 ? void 0 : _item$thresholds$$cur.amount,
                  amount: (_item$benefits$ = item.benefits[0]) === null || _item$benefits$ === void 0 ? void 0 : (_item$benefits$$fixed = _item$benefits$.fixedAmount) === null || _item$benefits$$fixed === void 0 ? void 0 : _item$benefits$$fixed.amount
                };
              });
              showCoupon.value = true;
              promotions.value = findOptimalPromotion(promotionList, Number((_props$price = props.price) === null || _props$price === void 0 ? void 0 : _props$price.total));
              emit('update:promotions', promotions.value);
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0, 'getPromotionInfosByPromotionIds---api---error');
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 11]]);
      }));
      return function getPromotionInfo(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var getPromotions = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _PromotionsData$promo, promotionsIds, _yield$getNewCustomer, PromotionsData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              promotionsIds = [];
              _context3.next = 4;
              return getNewCustomerPromotions({
                encryptedMarketplaceId: ENCRYPTED_MARKETPLACE_ID
              });
            case 4:
              _yield$getNewCustomer = _context3.sent;
              PromotionsData = _yield$getNewCustomer.data;
              PromotionsData === null || PromotionsData === void 0 ? void 0 : (_PromotionsData$promo = PromotionsData.promotions) === null || _PromotionsData$promo === void 0 ? void 0 : _PromotionsData$promo.forEach(item => {
                if (item.status === COUPON_SERVICE_PROMOTION_STATUS.ACTIVE) {
                  promotionsIds.push(item.promotionId);
                }
              });
              promotionIds.value = promotionsIds;
              _context3.next = 13;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0, 'getNewCustomerPromotions---api---error');
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 10]]);
      }));
      return function getPromotions() {
        return _ref3.apply(this, arguments);
      };
    }();
    var getIsNewCustomer = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _yield$getCustomerAct, data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return isLoginAuthenticated(false);
            case 3:
              if (!_context4.sent) {
                _context4.next = 9;
                break;
              }
              _context4.next = 6;
              return getCustomerActualPurchase();
            case 6:
              _yield$getCustomerAct = _context4.sent;
              data = _yield$getCustomerAct.data;
              if (data.hasActualPurchase === false) {
                cptIsNewCustomer.value = true;
                getPromotions();
              }
            case 9:
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](0);
              console.error(_context4.t0, 'getCustomerActualPurchase---api---error');
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 11]]);
      }));
      return function getIsNewCustomer() {
        return _ref4.apply(this, arguments);
      };
    }();
    watch(() => {
      var _props$price2;
      return [(_props$price2 = props.price) === null || _props$price2 === void 0 ? void 0 : _props$price2.total, promotionIds.value];
    }, /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(valueArray) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(valueArray[0] && valueArray[1].length > 0 && cptIsNewCustomer.value)) {
                _context5.next = 3;
                break;
              }
              _context5.next = 3;
              return getPromotionInfo(valueArray[1]);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }(), {
      immediate: true
    });
    var redeemCoupon = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(item) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return redeemPromotionForCurrentCustomer({
                encryptedPromotionId: item.id,
                encryptedMarketId: encryptedMarketplaceId
              });
            case 3:
              showCoupon.value = false;
              emit('updatePurchase');
              _context6.next = 7;
              return getPromotions();
            case 7:
              _context6.next = 12;
              break;
            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](0);
              console.error(_context6.t0, 'redeemPromotionForCurrentCustomer---api---error');
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 9]]);
      }));
      return function redeemCoupon(_x4) {
        return _ref6.apply(this, arguments);
      };
    }();
    onMounted(() => {
      getIsNewCustomer();
    });
    return (_ctx, _cache) => {
      var _props$price$total, _promotions$value, _props$price$promoti, _props$price$discoun, _props$price$importF, _props$price$origina, _props$price$shippin;
      var _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('modules.checkout.TOTAL_AMOUNT_OF_PRODUCTS')), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
        class: _normalizeClass(["price", {
          'is-loading': __props.isLoading
        }])
      }, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString((_props$price$total = __props.price.total) === null || _props$price$total === void 0 ? void 0 : _props$price$total.toFixed(2)), 3)])]), (_promotions$value = promotions.value) !== null && _promotions$value !== void 0 && _promotions$value.text && showCoupon.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('modules.checkout.NEWCOMER_COUPON_FOR_ALL_MERCHANTS')) + " " + _toDisplayString(_unref(t)('common.FULL_REDUCTION_COUPON', {
        amount: promotions.value.threshold,
        promotion: promotions.value.amount
      })), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", {
        class: "goTicket",
        onClick: _cache[0] || (_cache[0] = $event => redeemCoupon(promotions.value))
      }, [_createTextVNode(_toDisplayString(_unref(t)('modules.checkout.COUPON_DEDUCTION')) + " ¥" + _toDisplayString(promotions.value.amount), 1), _createVNode(_component_van_icon, {
        name: "arrow"
      })])])])) : _createCommentVNode("", true), ((_props$price$promoti = __props.price.promotionList) === null || _props$price$promoti === void 0 ? void 0 : _props$price$promoti.length) > 0 && __props.price.discount > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, " -" + _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString((_props$price$discoun = __props.price.discount) === null || _props$price$discoun === void 0 ? void 0 : _props$price$discoun.toFixed(2)), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createTextVNode(_toDisplayString(_unref(t)('modules.checkout.CSF')) + " ", 1), _createElementVNode("img", {
        class: "question import-fee-question",
        onClick: _cache[1] || (_cache[1] = $event => clickHandle(_unref(popUpType).CSF_DESC)),
        src: GREY_TIP,
        alt: ""
      })]), _createElementVNode("div", _hoisted_15, [_createElementVNode("span", {
        class: _normalizeClass(["price", {
          'is-loading': __props.isLoading
        }])
      }, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString((_props$price$importF = __props.price.importFee) === null || _props$price$importF === void 0 ? void 0 : _props$price$importF.toFixed(2)), 3)])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createTextVNode(_toDisplayString(_unref(t)('modules.checkout.SHIPPINGFEE')) + " ", 1), _createElementVNode("img", {
        class: "question shipping-fee-question",
        onClick: _cache[2] || (_cache[2] = $event => clickHandle(_unref(popUpType).SHIPPING_FEE_DESC)),
        src: GREY_TIP,
        alt: ""
      })]), _createElementVNode("div", _hoisted_18, [__props.addressInfo ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.price.originalShippingFee !== __props.price.shippingFee ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('modules.checkout.REDUCED_SHIPPING_FEE_FOR_ORDERS_OVER_THESHOLD')), 1), _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString((_props$price$origina = __props.price.originalShippingFee) === null || _props$price$origina === void 0 ? void 0 : _props$price$origina.toFixed(2)), 1)], 64)) : _createCommentVNode("", true), _createElementVNode("span", {
        class: _normalizeClass(["price", {
          'red-price': __props.price.originalShippingFee !== __props.price.shippingFee,
          'is-loading': __props.isLoading
        }])
      }, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString((_props$price$shippin = __props.price.shippingFee) === null || _props$price$shippin === void 0 ? void 0 : _props$price$shippin.toFixed(2)), 3)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(t)('modules.checkout.VIEW_AFTER_SELECTING_AN_ADDRESS')), 1))])]), _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('modules.checkout.UNABLE_PROVIDE_INVOICES_GLOBAL_STORE_PURCHASES')), 1), (_openBlock(), _createBlock(_Teleport, {
        to: "#app"
      }, [_createVNode(PopUp, {
        class: "spc-text-pop",
        show: show.value,
        "onUpdate:show": _cache[3] || (_cache[3] = $event => show.value = $event),
        content: popText.content,
        title: popText.title,
        btnConfirmText: _unref(t)('modules.checkout.I_UNDERSTAND')
      }, null, 8, ["show", "content", "title", "btnConfirmText"])]))]);
    };
  }
};